import * as React from 'react';

export const gridConfig = {
  columns: [
    { name: 'name', title: 'Name' },
    { name: 'username', title: 'UserName' },
    { name: 'countryName', title: 'Country' },
    { name: 'departmentName', title: 'Department' },
    { name: 'subDepartmentName', title: 'Subdepartment' },
    { name: 'type', title: 'Role' },
    {
      component: ({ value }: any) => <span>{value ? 'yes' : 'no'}</span>,
      name: 'status',
      title: 'Active',
    },
  ],
  title: 'Users',
};
